import DataStore from '../../../../api/datastore/DataStore'

const DataStorePlugin = {

  install (Vue, options) {
    // Register a helper prototype property for store access.
    Object.defineProperty(Vue.prototype, '$DataStore', {
      get () {
        return DataStore
      }
    })

    // Register a global mixin to manage the getters/setters for our store.
    Vue.mixin({
      beforeCreate () {
        registerStore(this)
      }
    })
  }

}

export default DataStorePlugin

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(DataStorePlugin)
}

function registerStore (vm) {
  // 1.) Check for a DataStore "option" on the component.
  // 2.) Check for a DataStore "object" on the plugin.
  if (typeof vm.$options.DataStore !== 'undefined' && typeof DataStore !== 'undefined') {
    // Initialize the computed option if it hasn't already been initialized.
    if (typeof vm.$options.computed === 'undefined') {
      vm.$options.computed = {}
    }

    // Check if the store option is a non-empty array.
    if (Array.isArray(vm.$options.DataStore)) {
      // Loop through the elements of the "store" option.
      vm.$options.DataStore.forEach(property => {
        // Create a computed property using our DataStoreAccessor helper class.
        vm.$options.computed[property] = dataStoreAccessor(property)
      })
    } else {
      // Loop through the store options.
      for (var key in vm.$options.DataStore) {
        if (typeof vm.$options.DataStore[key] === 'function') {
          // Handle a function
          vm.$options.computed[key] = dataStoreAccessor(vm.$options.DataStore[key]())
        } else if (typeof vm.$options.DataStore[key] === 'string') {
          // Handle a string
          vm.$options.computed[key] = dataStoreAccessor(vm.$options.DataStore[key])
        }
      }
    }
  }
}

function dataStoreAccessor (key) {
  return {
    get () {
      return key.split('.').reduce((pValue, cValue) => {
        return pValue[cValue]
      }, DataStore)
    },

    set (value) {
      var path = key.split('.')
      var length = path.length - 1
      var store = DataStore

      for (var i = 0; i < length; i++) {
        if (store.hasOwnProperty(path[i])) {
          store = store[path[i]]
        }
      }

      store[path[i]] = value
    }
  }
}
